import { render } from "./ServiceCenter.vue?vue&type=template&id=7a4992d8&scoped=true"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"

import "./ServiceCenter.vue?vue&type=style&index=0&id=7a4992d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4992d8"]])

export default __exports__